import { render, staticRenderFns } from "./ManageStaffAdd.vue?vue&type=template&id=0ff27f27&"
import script from "./ManageStaffAdd.vue?vue&type=script&lang=js&"
export * from "./ManageStaffAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports